import { NavLink, useLocation, Link } from "react-router-dom";
import Button from "../ui/Button.jsx";

const PAGE_TITLES = [
  { prefix: "/dashboard/topic-ideas", title: "Topic Ideas" },
  { prefix: "/dashboard/project", title: "Projects" },
  { prefix: "/dashboard/siwes", title: "SIWES Report" },
  { prefix: "/dashboard/editor", title: "Word Editor" },
  { prefix: "/dashboard/payments", title: "Payments" },
  { prefix: "/dashboard/referrals", title: "Referrals" },
  { prefix: "/dashboard/usage", title: "Usage" },
  { prefix: "/dashboard/get-in-touch", title: "Get in Touch" },
  { prefix: "/dashboard/account", title: "Account" },
];

const NAV_GROUPS = [
  {
    label: "Workspace",
    items: [
      {
        label: "Topic Ideas",
        to: "/dashboard/topic-ideas",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
          </svg>
        ),
      },
      {
        label: "Projects",
        to: "/dashboard/project",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
        ),
      },
      {
        label: "SIWES Report",
        to: "/dashboard/siwes",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
          </svg>
        ),
      },
    ],
  },
  {
    label: "Tools",
    items: [
      {
        label: "Word Editor",
        to: "/dashboard/editor",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487 18.75 2.6a2.121 2.121 0 0 1 3 3L9.75 17.6 3 19.5l1.9-6.75 11.962-8.263Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 7.125 16.875 4.5" />
          </svg>
        ),
      },
    ],
  },
  {
    label: "Billing",
    items: [
      {
        label: "Payments",
        to: "/dashboard/payments",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5m-18 0h16.5A1.5 1.5 0 0 1 21.75 9.75v8.25a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V9.75a1.5 1.5 0 0 1 1.5-1.5Zm3.75 6h3" />
          </svg>
        ),
      },
      {
        label: "Usage",
        to: "/dashboard/usage",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12.75V4.875c0-.621.504-1.125 1.125-1.125h13.5c.621 0 1.125.504 1.125 1.125v15.25c0 .621-.504 1.125-1.125 1.125H9.75" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12.75h6.375c.621 0 1.125.504 1.125 1.125v6.25M13.5 9.75h4.5M13.5 12.75h4.5" />
          </svg>
        ),
      },
      {
        label: "Referrals",
        to: "/dashboard/referrals",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 9.75h1.5m-1.5 3h1.5m-7.5 6.75h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75h-12A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 19.5Z" />
          </svg>
        ),
      },
    ],
  },
  {
    label: "Support",
    items: [
      {
        label: "Get in Touch",
        to: "/dashboard/get-in-touch",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z" />
          </svg>
        ),
      },
      {
        label: "Account",
        to: "/dashboard/account",
        icon: (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          </svg>
        ),
      },
    ],
  },
];

const getPageTitle = (pathname) => {
  const match = PAGE_TITLES.find(({ prefix }) => pathname.startsWith(prefix));
  return match?.title || "Dashboard";
};

const getInitials = (name, email) => {
  const source = (name || email || "A").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
};

const NavItem = ({ label, to, icon }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      [
        "group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200",
        isActive
          ? "bg-emerald-50 text-emerald-900 shadow-sm ring-1 ring-emerald-100"
          : "text-slate-600 hover:bg-slate-50 hover:text-slate-900",
      ].join(" ")
    }
  >
    {({ isActive }) => (
      <>
        {isActive && (
          <span className="absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-[#0BBF64]" />
        )}
        <span
          className={`transition-colors ${
            isActive ? "text-[#0BBF64]" : "text-slate-400 group-hover:text-slate-600"
          }`}
        >
          {icon}
        </span>
        <span>{label}</span>
      </>
    )}
  </NavLink>
);

const DashboardLayout = ({ onLogout, user, children }) => {
  const location = useLocation();
  const pageTitle = getPageTitle(location.pathname);
  const displayName = user?.name || user?.fullName || "Student";
  const displayEmail = user?.email || "";
  const initials = getInitials(displayName, displayEmail);

  return (
    <div className="min-h-screen bg-slate-50/80">
      <div className="drawer lg:drawer-open">
        <input id="dashboard-drawer" type="checkbox" className="drawer-toggle" />

        <div className="drawer-content flex min-h-screen flex-col">
          <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/80 backdrop-blur-xl">
            <div className="flex items-center justify-between gap-4 px-4 py-3 lg:px-8">
              <div className="flex min-w-0 items-center gap-3">
                <label
                  htmlFor="dashboard-drawer"
                  className="inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 lg:hidden"
                  aria-label="Open menu"
                >
                  <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </label>
                <div className="min-w-0">
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 lg:hidden">
                    Astudent
                  </p>
                  <h1 className="truncate text-base font-bold tracking-tight text-slate-900 sm:text-lg">
                    {pageTitle}
                  </h1>
                </div>
              </div>

              <div className="flex items-center gap-2 sm:gap-3">
                <div className="hidden items-center gap-2.5 rounded-xl border border-slate-200/80 bg-slate-50/80 px-3 py-1.5 sm:flex">
                  <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-[#0BBF64] to-emerald-600 text-[10px] font-bold text-white">
                    {initials}
                  </span>
                  <div className="min-w-0 max-w-[140px]">
                    <p className="truncate text-xs font-semibold text-slate-900">
                      {displayName}
                    </p>
                    {displayEmail && (
                      <p className="truncate text-[10px] text-slate-500">
                        {displayEmail}
                      </p>
                    )}
                  </div>
                </div>
                <Button variant="outline" size="sm" onClick={onLogout}>
                  Logout
                </Button>
              </div>
            </div>
          </header>

          <main className="flex-1 px-4 py-6 lg:px-8 lg:py-8">
            <div className="mx-auto max-w-6xl animate-fade-up">{children}</div>
          </main>
        </div>

        <aside className="drawer-side z-50">
          <label
            htmlFor="dashboard-drawer"
            className="drawer-overlay"
            aria-label="Close sidebar"
          />

          <div className="flex min-h-full w-72 flex-col border-r border-slate-200/80 bg-white">
            <div className="border-b border-slate-100 p-5">
              <Link to="/dashboard/topic-ideas" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-[#0BBF64] to-emerald-600 text-sm font-bold text-white shadow-sm shadow-emerald-500/20">
                  A
                </span>
                <div>
                  <span className="block font-extrabold text-lg tracking-tight text-slate-900">
                    Astudent
                  </span>
                  <span className="block text-[10px] font-medium text-slate-400">
                    Student workspace
                  </span>
                </div>
              </Link>
            </div>

            <nav className="flex-1 overflow-y-auto p-4">
              {NAV_GROUPS.map((group) => (
                <div key={group.label} className="mb-5 last:mb-0">
                  <p className="mb-2 px-3 text-[10px] font-semibold uppercase tracking-wider text-slate-400">
                    {group.label}
                  </p>
                  <div className="space-y-0.5">
                    {group.items.map((item) => (
                      <NavItem
                        key={item.to}
                        label={item.label}
                        to={item.to}
                        icon={item.icon}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </nav>

            <div className="border-t border-slate-100 p-4">
              <div className="flex items-center gap-3 rounded-xl bg-slate-50 p-3 ring-1 ring-slate-100">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-[#0BBF64] to-emerald-600 text-xs font-bold text-white">
                  {initials}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-slate-900">
                    {displayName}
                  </p>
                  {displayEmail && (
                    <p className="truncate text-xs text-slate-500">
                      {displayEmail}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default DashboardLayout;
